import React from "react";
import { connect } from "react-redux";
import Z3 from "../components/Z3";
import StatsUtils from "../../../utils/stats";
import { getCurrentDimensionSelected, getKpiSelected } from "../selectors";

const mapStateToProps = (state) => {
	return {
		kpi: getKpiSelected(state),
		filters: StatsUtils.zoneToFilters(state.stats.zones.z3),
		dimension: getCurrentDimensionSelected(state),
	};
};

export default connect(
	mapStateToProps,
	{},
)(Z3);



// WEBPACK FOOTER //
// src/modules/stats/containers/Z3Container.js